import type { RootState } from "../types/store.types";

export const selectVersionHistory = (state: RootState) => state.versionHistory.versionHistory;
export const selectVersionHistoryLoading = (state: RootState) => state.versionHistory.isLoading;
export const selectVersionHistoryError = (state: RootState) => state.versionHistory.error;
export const selectVersionHistoryBackupConfiguration = (state: RootState) => state.versionHistory.backupConfiguration;
export const selectVersionHistoryPreviewData = (state: RootState) => state.versionHistory.previewData;
export const selectVersionHistoryCurrentConfiguration = (state: RootState) => state.versionHistory.currentConfiguration;
